// client/src/App.js

import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import "./styles/custom.scss";

import { AuthProvider } from "./context/AuthContext";
import AppNavbar from "./components/AppNavbar";
import ProtectedRoute from "./components/ProtectedRoute"; // ✅ Import the guard
import LoginPage from "./pages/LoginPage";
import ProfilePage from "./pages/ProfilePage";
import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";
import FavoritesPage from "./pages/FavoritesPage";
import BookingsPage from "./pages/BookingsPage";

const App = () => {
  // The search state is still managed here
  const [searchQuery, setSearchQuery] = useState("");
  const [searchType, setSearchType] = useState("");
  const [date, setDate] = useState(() => { /* ... */ });
  
  return (
    <AuthProvider>
      <Router>
        <AppNavbar
          searchQuery={searchQuery} setSearchQuery={setSearchQuery}
          searchType={searchType} setSearchType={setSearchType}
          date={date} setDate={setDate}
        />
        <Layout>
          <Routes>
            {/* --- Public Route --- */}
            {/* The login page is available to everyone */}
            <Route path="/login" element={<LoginPage />} />

            {/* --- Protected Routes --- */}
            {/* All routes inside this wrapper will require a user to be logged in */}
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<SearchPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/favorite-courses" element={<FavoritesPage />} />
              <Route path="/bookings" element={<BookingsPage />} />
            </Route>
            
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
};

export default App;